/**
 * схема для аналитики
 * @property {array} headerAnalyticsItems - элементы хэдера
 * @property {Object} supplyersAnalyticsTabs - табы для страницы операторы
 * @property {Object} clientConditionsAnalyticsTabs - табы для страницы клиенты условия
 */
let schemeAnalytics = {
    headerAnalyticsItems: [
        {
            name: 'Бюджет',
            route: '/analytics/summary',
        },
        {
            name: 'ТОП',
            route: '/analytics/top',
        },
        {
            name: 'Клиенты',
            route: '/analytics/clients',
        },
        {
            name: 'Менеджеры',
            route: '/analytics/managers',
        },
        {
            name: 'Направления',
            route: '/analytics/directions',
        },
        {
            name: 'Операторы',
            route: '/analytics/supplyers',
        },
        {
            name: 'Клиент условия',
            route: '/analytics/client-condition',
        }
    ],
    supplyersAnalyticsTabs: {
        default: {
            title: 'Формат - Клиент'
        },
        back: {
            title: 'Клиент - Формат'
        },
    },
    clientConditionsAnalyticsTabs: {
        default: {
            title: 'Город - Оператор'
        },
        back: {
            title: 'Оператор - Город'
        },
    },
    groupingLabels: {
        brand: {
            single: 'Бренд',
            multi: 'Бренды'
        },
        client: {
            single: 'Клиент',
            multi: 'Клиенты'
        }
    }
};

export default schemeAnalytics;